import { AsyncStateNotification } from '@ui/notifications';
import { coreActions } from '@sonar-software/sonar-core';
import { LoadingSpinner } from '@ui/LoadingSpinner';

import { createAsyncSelectors, createSonarSelector } from '@lib/selectors';
import { Form, Switch } from 'antd';
import { NOTIFICATION_PREFERENCES_COPY, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useAsyncStateWithPreload, useCurrentUser } from '@hooks';

const selectors = createAsyncSelectors((state) => state.core.users.byId.notificationPrefs.get);
const patchStateSelector = createSonarSelector((state) => state.core.users.byId.notificationPrefs.patch);

export const NotificationPreferences: React.FC = () => {
	const { id: userId } = useCurrentUser();

	const { isRequested, data } = useAsyncStateWithPreload(
		selectors,
		coreActions.requestGetCoreUsersByIdNotificationPreferences,
		true,
		{ userId }
	);

	const patchPreferences = useAction(coreActions.requestPatchCoreUsersByIdNotificationPreferences);

	const handleMentionChange = useCallback((value: boolean) => {
		patchPreferences({
			allowMentionEmails: value,
			userId
		});
	},
	[ patchPreferences, userId ]);

	return (
		<>
			<div id='notification-preferences'>
				<LoadingSpinner spinning={ isRequested }>
					<Form colon={ false }>
						<Form.Item
							className='horizontal-form-item'
							label={ NOTIFICATION_PREFERENCES_COPY.EMAIL_WHEN_AT_MENTIONED }
							name='allowMentionEmails'>
							<Switch
								checked={ data?.allowMentionEmails }
								onChange={ handleMentionChange } />
						</Form.Item>
					</Form>
				</LoadingSpinner>
			</div>
			<AsyncStateNotification
				errored={ NOTIFICATIONS_COPY.ERROR_PATCH_USER_PREFERENCES }
				failed={ NOTIFICATIONS_COPY.FAILED_PATCH_USER_PREFERENCES }
				received={ NOTIFICATIONS_COPY.SUCCESS_PATCH_USER_PREFERENCES }
				resetRawAction={ coreActions.resetPatchCoreUsersByIdNotificationPreferences }
				stateSelector={ patchStateSelector } />
		</>
	);
};
